import { pwaDidAppear$ } from '@shopgate/engage/core';
import { fetchUser } from '@shopgate/engage/user';

/**
 * GuestCheckout subscriptions.
 * @param {Function} subscribe The subscribe function.
 */
export default function guestCheckout(subscribe) {
  // This subscribers file actually should register a redirect to enable the PWA based guest
  // checkout.
  // To improve developer experience this happens inside the subscribers of the
  // @shopgate/connect extension. So only one extension needs to be attached during development.

  subscribe(pwaDidAppear$, ({ dispatch }) => {
    setTimeout(() => {
      dispatch(fetchUser());
    }, 1000);
  });
}
